import React from "react";
import { PDFDocument } from "pdf-lib";
import moment from "moment";
import jsPDF from "jspdf";
import ReactDOMServer from "react-dom/server";

// Generate Single PDF
const generatePDF = (element, mode = 'l') => {
    let pdf = new jsPDF(mode, 'pt', 'a4');
    return new Promise((resolve, reject) => {
        pdf.html(ReactDOMServer.renderToString(element), {
            callback: function (doc) {
                resolve(doc.output('arraybuffer'));
            }
        });
    });
}

// Merged Multiple PDF in a single PDF
export const mergePdfs = async (pdfsToMerge) => {
    const mergedPdf = await PDFDocument.create();

    const createInnerPromise = async (arrayBuffer) => {
        const pdfdoc = await PDFDocument.load(arrayBuffer);
        return await mergedPdf.copyPages(pdfdoc, pdfdoc.getPageIndices());
    };

    const outerPromise = pdfsToMerge.map((arrayBuffer) => {
        const innerPromise = createInnerPromise(arrayBuffer);
        return innerPromise;
    });

    const resultOuterPromise = await Promise.all(outerPromise);

    resultOuterPromise.forEach((pageArray) => {
        pageArray.forEach((page) => {
            mergedPdf.addPage(page);
        });
    });

    const mergedPdfFile = await mergedPdf.save();
    return mergedPdfFile;
}

// Generate & Download PDF
export const generateAndDownloadPdf = async (element, preview = false, mode, isDownload = false, fileName = 'Vision Product') => {
    const pdfs = [];
    for (const ele of element) {
        const doc = await generatePDF(ele, mode);
        pdfs.push(doc);
    }
    const mergedPdf = await mergePdfs(pdfs);
    await downloadPdf(mergedPdf, preview, isDownload, fileName);

}

export const downloadPdf = async (pdf, preview = false, isDownload = false, fileName = 'Vision Product') => {
    const blob = new Blob([pdf], { type: 'application/pdf' });
    const url = URL.createObjectURL(blob);
    if (!preview) {
        var iframe = document.createElement('iframe');
        iframe.style.display = 'none';
        iframe.src = url;
        document.body.appendChild(iframe);
        iframe.onload = function () {
            iframe.contentWindow.print();
        }
    } else {
        window.open(url, '_blank');

        // Download the merged PDF
        if (isDownload) {

            const downloadLink = document.createElement('a');
            downloadLink.href = url;
            downloadLink.download = fileName;
            document.body.appendChild(downloadLink);
            downloadLink.click();
            document.body.removeChild(downloadLink);
        }
    }
}